import * as React from 'react';
import { GraduationCap } from 'lucide-react';
import { ClassesGrid, type ClassDraft } from '@/components/forms/ClassesGrid';
import { ESTABLISHMENT_TYPES_WITH_CLASSES } from '@/components/establishments/establishment-configs';
import type { EstablishmentFormMode, EstablishmentFormState } from '@/types/establishment.types';

/** Props for {@link EstablishmentClassesSection}. */
interface Props {
  mode: EstablishmentFormMode;
  form: EstablishmentFormState;
  onFieldChange: (field: string, value: unknown) => void;
  classesError: string | null;
}

/** Classes list on the establishment form. */
export function EstablishmentClassesSection({
  mode,
  form,
  onFieldChange,
  classesError,
}: Readonly<Props>) {
  function handleClassesChange(classes: ClassDraft[]): void {
    onFieldChange('classes', classes);
  }

  if (!form.type || !ESTABLISHMENT_TYPES_WITH_CLASSES.has(form.type)) {
    return null;
  }

  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <GraduationCap className="w-4 h-4" />
        Classes
      </h4>
      <ClassesGrid value={form.classes} onChange={handleClassesChange} disabled={false} />
      {renderClassesHint(mode, classesError)}
    </div>
  );
}

/** Validation error or optional-classes hint under the classes grid. */
function renderClassesHint(
  mode: EstablishmentFormMode,
  classesError: string | null,
): React.ReactNode {
  if (classesError) {
    return <p className="text-xs text-red-500 mt-2 font-medium">{classesError}</p>;
  }
  const hint =
    mode === 'create'
      ? 'Définissez les classes de cet établissement (optionnel)'
      : 'Gérez les classes de cet établissement (optionnel)';
  return <p className="text-xs text-muted-foreground mt-2">{hint}</p>;
}
